import { ResponseData } from '../../../types'
import { BaseNode } from '../../../actionCard'

export class ResponseNode extends BaseNode {
  declare data: ResponseData

  public getLabelTemplate(): string {
    return this.data.answer
  }

  public getIsChecked(): boolean {
    return this.data.checked
  }

  public setIsChecked(value: boolean): void {
    this.data.checked = value
  }
}
